import React, { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { getUserNotificationConfig } from 'src/selectors/user'
import { EmailNotificationsConfigItem } from './EmailNotificationsConfigItem'
import NotificationsDisabledImage from 'src/assets/images/notifications-disabled.svg'
import { colors } from 'src/theme'
import { UserNotificationPeriod } from 'src/constants/user'

const EmailNotificationsSectionComponent = () => {
  const userNotificationConfig = useSelector(getUserNotificationConfig)

  if (!userNotificationConfig) {
    return null
  }

  return (
    <>
      {!userNotificationConfig.enabled && (
        <div css={tw`z-10 absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center`}>
          <div
            css={tw`z-10 bg-white rounded-lg p-4 items-center flex opacity-100 flex-col w-[301px] shadow-2xl mb-[300px]`}
          >
            <img src={NotificationsDisabledImage} alt="Notifications disabled" />
            <Typography css={tw`mt-2 mb-1`} variant="h4">
              Email notifications disabled
            </Typography>
            <Typography css={tw`text-center`} variant="body2" color={colors.SHADES_GREY_400}>
              To manage your email notifications, please enable them first by using the toggle
              switch.
            </Typography>
          </div>

          <div
            css={tw`absolute top-0 bottom-0 left-0 right-0 bg-white opacity-40 flex items-center justify-center`}
          />
        </div>
      )}
      <Typography css={tw`mb-2`} variant="h4">
        Email notifications
      </Typography>
      <EmailNotificationsConfigItem
        title="Notify when contractor is onboarded"
        enabledValueName="contractorsOnboardedEnabled"
        periodValueName="contractorsOnboardedPeriod"
      />
      <EmailNotificationsConfigItem
        title="Notify daily before contractor is deactivated"
        enabledValueName="contractorsDaysBeforeDeactivatedEnabled"
        periodValueName="contractorsDaysBeforeDeactivatedPeriod"
        enabledPeriods={[UserNotificationPeriod.Daily]}
      />
      <EmailNotificationsConfigItem
        title="Notify when contractor is deactivated"
        enabledValueName="contractorsDeactivatedEnabled"
        periodValueName="contractorsDeactivatedPeriod"
      />
      <EmailNotificationsConfigItem
        title="Notify when contractor is reactivated"
        enabledValueName="contractorsReactivatedEnabled"
        periodValueName="contractorsReactivatedPeriod"
      />
      <EmailNotificationsConfigItem
        title="Notify when payment failed to process"
        enabledValueName="paymentFailedToProcessEnabled"
        periodValueName="paymentFailedToProcessPeriod"
      />
      <EmailNotificationsConfigItem
        title="Notify when payment failed due to contractor compliance"
        enabledValueName="paymentFailedContractorComplianceEnabled"
        periodValueName="paymentFailedContractorCompliancePeriod"
      />
      <EmailNotificationsConfigItem
        title="Notify when payment is processed in a grace period"
        enabledValueName="paymentInGracePeriodEnabled"
        periodValueName="paymentInGracePeriodPeriod"
      />
      <EmailNotificationsConfigItem
        title="Notify when contractor has expiring soon files"
        enabledValueName="contractorExpiringSoonFilesEnabled"
        periodValueName="contractorExpiringSoonFilesPeriod"
        enabledPeriods={[UserNotificationPeriod.Daily]}
      />
    </>
  )
}

export const EmailNotificationsSection = memo(EmailNotificationsSectionComponent)
